import React from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";

const CustodiaTitulosMantView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <TitlePage title='Mantenimientos / Custodia Títulos'/>
                    </Grid>
                    <Grid item xs={12}>
                        <div className="p-grid">
                            <div className="p-col-12" style={{textAlign: "right"}}>
                                <Button label="Guardar" onClick={props.openConfMsgSaveInst}/>
                            </div>
                            <div className="p-col-8">
                                <DataTable value={props.dataInstitutions}
                                           responsive={true}
                                           resizableColumns={true}
                                           columnResizeMode={"fit"}>
                                    <Column style={{width: '10%', textAlign: 'center'}} field="automatic"
                                            header={"Automático"}
                                            body={props.automaticTemplate}/>
                                    <Column field="nombreCorto" header="Institución"
                                            style={{textAlign: 'left'}}
                                            sortable={true}/>
                                </DataTable>
                                <div className="p-col-4"/>
                            </div>
                        </div>
                        {props.confMsgSave}
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default (CustodiaTitulosMantView);